import { APIEndpoints } from '@assembly-web/services';
import { useMutation } from '@tanstack/react-query';

import { assemblyAPI } from '../../../services/assemblyAPI';

export function useAssemblySettingsMutation() {
  return useMutation((payload: unknown) =>
    assemblyAPI.put(APIEndpoints.updateAssemblySettings, payload)
  );
}
